module.exports = __webpack_public_path__ + "img/avatar.404abdbf.png";